import { backendServices } from '../services';

/** Reads a boolean buyer feature from the FeaturesEnabled bag (CSP / public settings). */
export function isBuyerPortalFeatureEnabled(
    settings: Pick<backendServices.ViewModels.BuyerPortalSettingsViewModel, 'FeaturesEnabled'> | null | undefined,
    featureName: string
): boolean {
    return settings?.FeaturesEnabled?.Features?.[featureName]?.toLowerCase() === 'true';
}
